import { Route, useLocation, Routes, Navigate } from 'react-router-dom'; 
import { Suspense, useEffect } from 'react';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';
import LoadingPage from './components/global/LoadingPage';
import Login from './pages/auth/Login';
import ProtectedRoute from './components/global/ProtectedRoute';
import Home from './pages/Home';
import Layout from './layout/Layout';
import Register from './pages/auth/Register';
import Profile from './pages/profile/Profile';

// Import modular routes
import categoriesRoutes from './routes/categoriesRoutes';
import brandsRoutes from "./routes/brandsRoutes";
import departmentsRoutes from './routes/departmentsRoutes';
import tagsRoutes from './routes/tagsRoutes';
import optionGroupsRoutes from './routes/optionGroupsRoutes';
import productsRoutes from './routes/productsRoutes';
import collectionsRoutes from './routes/collectionsRoutes';
import pagesRoutes from './routes/pagesRoutes';
import homeSectionsRoutes from './routes/homeSectionsRoutes';
import blogRoutes from './routes/blogRoutes';
import couponsRoutes from './routes/couponsRoutes';
import ordersRoutes from './routes/ordersRoutes';
import returnsRoutes from './routes/returnsRoutes';
import shippingRoutes from './routes/shippingRoutes';
import taxRoutes from './routes/taxRoutes';
import customersRoutes from './routes/customersRoutes';
import inventoryRoutes from './routes/inventoryRoutes';
import rolesRoutes from './routes/rolesRoutes';
import settingsRoutes from './routes/settingsRoutes';
import notificationTemplatesRoutes from './routes/notificationTemplatesRoutes';
import webhooksRoutes from './routes/webhooksRoutes';
import comingSoonRoutes from './routes/comingSoonRoutes';

// Pages
const RoutesPath = () => {
    const ScrollToTop = () => {
        const { pathname } = useLocation();
        useEffect(() => {
            window.scrollTo(0, 0);
        }, [pathname]);
        return null;
    };

    return (
        <>
            <ScrollToTop />
            <Suspense fallback={<LoadingPage />}>
                <Routes>
                    {/* Auth Routes */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />

                    {/* 403 Forbidden Page */}
                    <Route path="/forbidden" element={<Forbidden />} />

                    {/* Protected Routes */}
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <Layout />
                            </ProtectedRoute>
                        }>

                        {/* Home - Redirect to dashboard */}
                        <Route index element={<Navigate replace to="dashboard" />} />

                        {/* Dashboard - Available for all authenticated users */}
                        <Route path="dashboard" element={<Home />} />

                        {/* Profile - Available for all authenticated users */}
                        <Route path="profile" element={<Profile />} />

                        {/* Settings - Requires permission */}
                        {/* <Route
                            path="setting"
                            element={
                                <ProtectedRoute requiredPermission="settings_companies">
                                    <Settings />
                                </ProtectedRoute>
                            }
                        /> */}

                        {/* ============================================ */}
                        {/* Modular Routes - Each module in its own file */}
                        {/* ============================================ */}

                        {/* Departments Module */}
                        {departmentsRoutes}

                        {/* Categories Module */}
                        {categoriesRoutes}

                        {/* Brands Module */}
                        {brandsRoutes}

                        {/* Tags Module */}
                        {tagsRoutes}

                        {/* Option Groups Module */}
                        {optionGroupsRoutes}

                        {/* Products Module */}
                        {productsRoutes}

                        {/* Collections Module */}
                        {collectionsRoutes}

                        {/* Pages Module */}
                        {pagesRoutes}

                        {/* Home Sections Module */}
                        {homeSectionsRoutes}

                        {/* Blog Module */}
                        {blogRoutes}

                        {/* Coupons Module */}
                        {couponsRoutes}

                        {/* Orders Module (Sprint 1) */}
                        {ordersRoutes}

                        {/* Returns Module (Sprint 5) */}
                        {returnsRoutes}

                        {/* Shipping Module (Sprint 5) */}
                        {shippingRoutes}

                        {/* Tax Module (Sprint 5) */}
                        {taxRoutes}

                        {/* Customers Module (Sprint 4) */}
                        {customersRoutes}

                        {/* Inventory + Warehouses + Movements (Sprint 6) */}
                        {inventoryRoutes}

                        {/* Roles & Permissions (Sprint 7) */}
                        {rolesRoutes}

                        {/* Settings (Sprint 8) */}
                        {settingsRoutes}

                        {/* Notification Templates (Sprint 10) */}
                        {notificationTemplatesRoutes}

                        {/* Webhooks (Sprint 11.9 — Backend Sprint 15) */}
                        {webhooksRoutes}

                        {/* Placeholder routes for upcoming modules.
                            Replace each with its real module file
                            once the matching sprint ships. */}
                        {comingSoonRoutes}

                        {/* ============================================ */}
                        {/* Add more modular routes here */}
                        {/* ============================================ */}

                    </Route>
                    {/* End Protected Routes */}

                    {/* 404 Not Found */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Suspense>
        </>
    );
};

export default RoutesPath;